import { ICreateUserRequest, monthlyPopup } from "./../models/api.models";
import { API } from "aws-amplify";

export class UserApi {
  static async createUser(body: ICreateUserRequest) {
    return await API.post("user", ``, { body });
  }

  static async updateUser(body: ICreateUserRequest) {
    return await API.patch("user", ``, { body });
  }

  static async deleteUser(body: { email: string }) {
    return await API.del("user", ``, { body });
  }

  static async getAllUsers() {
    return await API.get("user", ``, {});
  }

  static async getUsers(hotelId: number) {
    return await API.get("user", `/${hotelId}`, {});
  }

  static async createHotelUser(
    hotelId: number,
    body: { email: string; permission: number },
  ) {
    return await API.post("user", `/${hotelId}`, { body });
  }

  static async deleteHotelUser(hotelId: number, body: { email: string }) {
    return await API.del("user", `/${hotelId}`, { body });
  }

  static async resetUserPassword(body: ICreateUserRequest) {
    return await API.post("user", `/reset`, {
      body,
    });
  }

  static async selfReset(body: {
    email: string;
    currentPassword: string;
    newPassword: string;
  }) {
    return await API.post("user", `/self-reset`, {
      body,
    });
  }

  static async listHotelUser(hotelId: number) {
    return await API.get("user", `/${hotelId}`, {});
  }

  static async getAttribute(userToken: string) {
    return await API.get("user", `/userAttribute/${userToken}`, {});
  }

  static async updateMonthlyPopupValue(body: monthlyPopup) {
    return await API.post("user", `/popupValue/${body.hotelIds}`, {
      body,
    });
  }

  static async remindMeLater(body: monthlyPopup) {
    return await API.post("user", `/remindMeLater/${body.hotelIds}`, {
      body,
    });
  }

  static async acknowledgeMigrationNotice() {
    return await API.post("user", `/acknowledge-migration`, {});
  }
}
